import { render, staticRenderFns } from "./realtimeBtnList.vue?vue&type=template&id=b7d5c490"
import script from "./realtimeBtnList.vue?vue&type=script&lang=js"
export * from "./realtimeBtnList.vue?vue&type=script&lang=js"
import style0 from "./realtimeBtnList.vue?vue&type=style&index=0&id=b7d5c490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports